import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Config } from '../../../shared/services/config';
// Nebular imports removed - no longer using NbLayoutModule

@Component({
  selector: 'ngx-one-column-layout',
  styleUrls: ['./one-column.layout.scss'],
  templateUrl: './one-column.layout.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    // NbLayoutModule removed
  ]
})
export class OneColumnLayoutComponent {
  db = Config;

  constructor() {
    Config.userChanged.subscribe(user => this.onUserChanged(user));
  }

  onUserChanged(user: any): void {
  }
}
